import "./app/publicPath";
// =========================
// Polyfill's
// =========================

import "custom-event-polyfill";

// =========================
// Framework's
// =========================

import Vue from "vue";
import { mount } from "./mount";

Vue.prototype.$mount = mount;

window.Vue = Vue;

import script2 from "./app/plugins/script2";
Vue.use(script2);

import "./app/jQuery";

import "bootstrap";
window._owlc = () => import("owl.carousel");

import { getUrlParams } from "./app/services/UrlService";
window.ceresEnv = getUrlParams()["env"];

import * as Sentry from "@sentry/vue";

if(window.App?.modeherzPluginConfig.errorLogging) {
    Sentry.init({
        release: 'modeherz@' + window.App?.modeherzPluginConfig.version,
        Vue: Vue,
        attachProps: true,
        dsn: "https://a6033ad31272bc91c4332912c23c1bf4@o4508120643993600.ingest.de.sentry.io/4508120645369936",
        integrations: [
            // Sentry.replayIntegration(),
            Sentry.browserProfilingIntegration(),
            Sentry.captureConsoleIntegration({levels: ['error']})
        ],
        profilesSampleRate: 0.05, // Profile 100% of the transactions. This value is relative to tracesSampleRate
        replaysOnErrorSampleRate: 1.0,
    });
}

// =========================
// COMPONENTS
// =========================
// Vue.component("add-item-to-basket-overlay", () => import("./app/components/basket/AddItemToBasketOverlay.vue"));

Vue.component("add-to-basket", () => import("./app/components/basket/AddToBasket.vue"));
Vue.component("basket-preview", () => import("./app/components/basket/BasketPreview.vue"));
Vue.component("basket-totals", () => import("./app/components/basket/BasketTotals.vue"));
Vue.component("mail-changed-info", () => import("./app/components/basket/MailChangedInfo.vue"));
Vue.component("coupon", () => import("./app/components/basket/Coupon.vue"));
Vue.component("basket-list", () => import("./app/components/basket/list/BasketList.vue"));

// Vue.component("step-by-step-navigation", () => import("./app/components/category/StepByStepNavigation.vue"));
// Vue.component("google-maps-widget", () => import("./app/components/common/GoogleMaps.vue"));
import LazyImg from "./app/components/common/LazyImg.vue";
Vue.component("lazy-img", LazyImg);
import Intersect from "./app/components/common/Intersect.vue";
Vue.component("intersect", Intersect);
// Vue.component("tab-list", () => import("./app/components/common/TabList.vue"));
// Vue.component("tab-item", () => import("./app/components/common/TabItem.vue"));
Vue.component("last-seen-item-list", () => import("./app/components/containers/LastSeenItemList.vue"));

Vue.component("change-email-form", () => import("./app/components/customer/ChangeEmailForm.vue"));
import ReCaptcha from "./app/components/customer/ReCaptcha.vue";
Vue.component("recaptcha", ReCaptcha);
Vue.component("registration", () => import("./app/components/customer/Registration.vue"));
Vue.component("reset-password-form", () => import("./app/components/customer/ResetPasswordForm.vue"));
Vue.component("forgot-password-modal", () => import("./app/components/customer/login/ForgotPassword.vue"));
Vue.component("guest-login", () => import("./app/components/customer/login/GuestLogin.vue"));
Vue.component("login", () => import("./app/components/customer/login/Login.vue"));
// legacy non-shopbuilder component
Vue.component("login-view", () => import("./app/components/customer/login/LoginView.vue"));
import UserLoginHandler from "./app/components/customer/login/UserLoginHandler.vue";
Vue.component("user-login-handler", UserLoginHandler);
Vue.component("form-attachment", () => import("./app/components/form/FormAttachment.vue"));

// Vue.component("item-bundle", () => import("./app/components/item/ItemBundle.vue"));
Vue.component("guarantee-badge", () => import("./app/components/item/GuaranteeBadge.vue"));
Vue.component("guarantee-label-full", () => import("./app/components/item/GuaranteeLabelFull.vue"));
Vue.component("quantity-input", () => import("./app/components/item/QuantityInput.vue"));

// Vue.component("tag-list", () => import("./app/components/item/TagList.vue"));

Vue.component("category-item", () => import("./app/components/itemList/CategoryItem.vue"));
// import ItemSearch from "./app/components/itemList/ItemSearch.vue";
// Vue.component("item-search", ItemSearch);
// Vue.component("search-suggestion-item", () => import("./app/components/itemList/SearchSuggestionItem.vue"));
// Vue.component("item-filter-list", () => import("./app/components/itemList/filter/ItemFilterList.vue"));
// Vue.component("item-filter-tag-list", () => import("./app/components/itemList/filter/ItemFilterTagList.vue"));

// Vue.component("live-shopping-item", () => import("./app/components/liveShopping/LiveShoppingItem.vue"));

Vue.component("newsletter-input", () => import("./app/components/newsletter/NewsletterInput.vue"));
Vue.component("newsletter-unsubscribe-input", () => import("./app/components/newsletter/NewsletterUnsubscribeInput.vue"));

// Vue.component("order-return", () => import("./app/components/orderReturn/OrderReturn.vue"));

// Vue.component("cookie-bar", () => import("./app/components/pageDesign/CookieBar.vue"));
Vue.component("privacy-settings", () => import("./app/components/pageDesign/PrivacySettings.vue"));
// Vue.component("carousel", () => import("./app/components/pageDesign/Carousel.vue"));
import Icon from "./app/components/pageDesign/Icon.vue";
Vue.component("icon", Icon);
// import LanguageDetection from "./app/components/pageDesign/LanguageDetection.vue";
// Vue.component("language-detection", LanguageDetection);
import MobileNavigation from "./app/components/pageDesign/MobileNavigation.vue";
Vue.component("mobile-navigation", MobileNavigation);
import Notifications from "./app/components/pageDesign/Notifications.vue";
Vue.component("notifications", Notifications);
Vue.component("popper", () => import("./app/components/pageDesign/Popper.vue"));
// Vue.component("shipping-country-select", () => import("./app/components/pageDesign/ShippingCountrySelect.vue"));
Vue.component("loading-animation", () => import("./app/components/pageDesign/LoadingAnimation.vue"));

Vue.component("wish-list", () => import("./app/components/wishList/WishList.vue"));
// import WishListCount from "./app/components/wishList/WishListCount.vue";
// Vue.component("wish-list-count", WishListCount);

import LazyLoad from "./app/components/common/LazyLoad.vue";
Vue.component("lazy-load", LazyLoad);

Vue.component("add-to-wish-list", () => import("./app/components/item/AddToWishList.vue"));
Vue.component("graduated-prices", () => import("./app/components/item/GraduatedPrices.vue"));
// Vue.component("item-data-table", () => import("./app/components/item/ItemDataTable.vue"));
// Vue.component("item-image-carousel", () => import("./app/components/item/ItemImageCarousel.vue"));
Vue.component("item-price", () => import("./app/components/item/ItemPrice.vue"));
// Vue.component("set-price", () => import("./app/components/item/SetPrice.vue"));
// Vue.component("order-property-list", () => import("./app/components/item/OrderPropertyList.vue"));
// Vue.component("variation-select", () => import("./app/components/item/VariationSelect.vue"));
// Vue.component("item-availability", () => import("./app/components/item/ItemAvailability.vue"));
// Vue.component("single-item-bundle", () => import("./app/components/item/SingleItemBundle.vue"));
Vue.component("single-add-to-basket", () => import("./app/components/item/SingleAddToBasket.vue"));
Vue.component("set-quantity-input", () => import("./app/components/item/SetQuantityInput.vue"));
import SingleItem from "./app/components/item/SingleItem.vue";
Vue.component("single-item", SingleItem);
// import SingleItemSetComponent from "./app/components/item/SingleItemSetComponent.vue";
// Vue.component("single-item-set-component", SingleItemSetComponent);


import LazyHydrate from "vue-lazy-hydration";
Vue.component("lazy-hydrate", LazyHydrate);
import ClientOnly from "./app/components/common/ClientOnly.vue";
Vue.component("client-only", ClientOnly);
import BackgroundImg from "./app/components/common/BackgroundImg.vue";
Vue.component("background-img", BackgroundImg);

// ====== MODEHERZ =======
Vue.component("mh-variation-tags", () => import("./modeherz/components/item/VariationTags.vue"));
Vue.component("mh-category-variation-tags",() => import("./modeherz/components/itemList/CategoryVariationTags.vue"));
Vue.component("mh-variation-selection", () => import("./modeherz/components/item/variationSelection/VariationSelection.vue"));
Vue.component("mh-product-safety-link", () => import("./modeherz/components/item/ProductSafetyLink.vue"));
Vue.component("mh-product-safety-modal", () => import("./modeherz/components/item/ProductSafetyModal.vue"));
Vue.component("mh-top-merchant-badge", () => import("./modeherz/components/item/TopMerchantBadge.vue"));
Vue.component("mh-category-variation-selection", () => import("./modeherz/components/itemList/CategoryVariationSelection.vue"));
Vue.component("mh-category-item-image", () => import("./modeherz/components/itemList/CategoryItemImage.vue"));
Vue.component("mh-category-variation-price",() => import("./modeherz/components/itemList/CategoryVariationPrice.vue"));
Vue.component("mh-share-buttons", () => import("./modeherz/components/item/ShareButtons.vue"));
Vue.component("mh-variation-price", () => import("./modeherz/components/item/VariationPrice.vue"));
Vue.component("mh-image360-button", () => import("./modeherz/components/item/Image360Button.vue"));
Vue.component("mh-image360-overlay", () => import("./modeherz/components/item/Image360Overlay.vue"));
Vue.component("mh-add-to-wish-list", () => import("./modeherz/components/item/AddToWishlistButton.vue"));
Vue.component("mh-manufacturer-image", () => import("./modeherz/components/item/ManufacturerImage.vue"));
Vue.component("mh-manufacturer-title", () => import("./modeherz/components/item/ManufacturerTitle.vue"));
Vue.component("mh-single-share-button", () => import("./modeherz/components/item/SingleShareButton.vue"));
Vue.component("mh-client-only", () =>import("./modeherz/components/common/MhClientOnly.vue"));
Vue.component("mh-item-image-carousel", () => import("./modeherz/components/item/ItemImageCarousel.vue"));
Vue.component("mh-item-image", () => import("./modeherz/components/item/ItemImage.vue"));
Vue.component("mh-item-search", () =>import("./modeherz/components/itemList/ItemSearch.vue"));
Vue.component("mh-carousel", () => import("./modeherz/components/pageDesign/Carousel.vue"));
Vue.component("mh-item-filter-tag-list", () => import("./modeherz/components/itemList/filter/components/ItemFilterTagList.vue"));
Vue.component("mh-item-filter-list", () => import("./modeherz/components/itemList/filter/components/ItemFilterList.vue"));
Vue.component("mh-shipping-country-select", () => import("./modeherz/components/pageDesign/ShippingCountrySelect.vue"));
Vue.component("mh-category-modal", () => import("./modeherz/components/pageDesign/CategoryModal.vue"));
Vue.component("mh-customer-service-modal", () => import("./modeherz/components/pageDesign/CustomerServiceModal.vue"));
import wishListCount from "./modeherz/components/wishlist/WishListCount.vue";
Vue.component("mh-wish-list-count", wishListCount );
Vue.component("mh-basket-price", () => import("./modeherz/components/basket/BasketPrice.vue"));
Vue.component("mh-order-now", () => import("./modeherz/components/item/OrderNow.vue"));

// =========================
// DIRECTIVES
// =========================
import "./app/directives/basket/basketItemQuantity";
import "./app/directives/basket/basketItemSum";
import "./app/directives/basket/toggleBasketPreview";

import "./app/directives/category/openFilterToolbar";

import "./app/directives/common/truncateTooltip";

import "./app/directives/customer/logout";

import "./app/directives/helper/testingAttr";
import "./app/directives/helper/populateStore";
import "./app/directives/helper/validate";
import "./app/directives/helper/waitingAnimation";
import "./app/directives/helper/waitingAnimationInfinite";

import "./app/directives/navigation/navigationTouchHandler";
import "./app/directives/navigation/openMobileNavigation";

import "./app/directives/pageDesign/scrollToTop";
import "./app/directives/pageDesign/stickInParent";
import "./app/directives/navigation/sidenavigationChildrenLoader";
import "./app/directives/pageDesign/tooltip";


// =========================
// FILTERS
// =========================
import "./app/filters/ageRestriction.filter";
import "./app/filters/arrayFirst.filter";
import "./app/filters/attachText.filter";
import "./app/filters/currency.filter";
import "./app/filters/date.filter";
import "./app/filters/fileName.filter";
import "./app/filters/fileUploadPath.filter";
import "./app/filters/graduatedPrice.filter";
import "./app/filters/hasItemDefaultPrice.filter";
import "./app/filters/inputUnit.filter";
import "./app/filters/itemBundleName.filter";
import "./app/filters/itemCrossPrice.filter";
import "./app/filters/itemImage.filter";
import "./app/filters/itemImageHeight.filter";
import "./app/filters/itemImageWidth.filter";
import "./app/filters/itemImageAlternativeText.filter";
import "./app/filters/itemImages.filter";
import "./app/filters/itemName.filter";
import "./app/filters/itemPrice.filter";
import "./app/filters/itemUrl.filter";
import "./app/filters/numberFormat.filter";
import "./app/filters/propertySurcharge.filter";
import "./app/filters/propertyFileUrl.filter";
import "./app/filters/translate.filter";
import "./app/filters/truncate.filter";


// =========================
// MIXINS
// =========================
import "./app/mixins/getJsonData.mixin";
import "./app/mixins/template.mixin";

// =========================
// Bootstrap frameworks
// =========================
import "./app/main";

import TranslationService from "./app/services/TranslationService";
import { createStore, initClientListeners, initClientStore, initServerStore, VuexModule } from "./app/store";
import { initListener } from "./app/services/ApiService";

window.ceresTranslate = TranslationService.translate;
window.Vuex = VuexModule

Vue.prototype.$translate = TranslationService.translate;
Vue.prototype.$ceres = App;

const store = createStore();

window.ceresStore = store;

initServerStore(store);
initClientStore(store);
initClientListeners(store);
initListener();
